class HelpModalController {
  constructor($uibModalInstance, helpTopic, showBrowser, HelpService) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.HelpService = HelpService;
    this.topic = helpTopic;
    this.showBrowser = !!showBrowser;
    this.topicsByCategory = HelpService.listTopicsByCategory();
    this.relatedTopics = HelpService.getRelatedTopics(helpTopic);
    this.categoryOrder = ['General', 'Employee', 'Manager', 'Admin'];
  }

  getCategories() {
    return this.categoryOrder.filter((category) => this.topicsByCategory[category] && this.topicsByCategory[category].length);
  }

  selectTopic(topicId) {
    const topic = this.HelpService.getTopic(topicId);
    if (!topic) {
      return;
    }
    this.topic = topic;
    this.showBrowser = topicId === 'overview';
    this.relatedTopics = this.HelpService.getRelatedTopics(topic);
    this.topicsByCategory = this.HelpService.listTopicsByCategory();
  }

  openRelated(topicId) {
    this.selectTopic(topicId);
  }

  backToBrowser() {
    const overview = this.HelpService.getTopic('overview');
    if (overview) {
      this.topic = overview;
      this.showBrowser = true;
      this.relatedTopics = this.HelpService.getRelatedTopics(overview);
    }
  }

  close() {
    this.$uibModalInstance.dismiss('close');
  }
}

export default HelpModalController;



// WEBPACK FOOTER //
// ./client/help/help-modal/help-modal.controller.js